import { Button, List } from '@mantine/core';
import { modals } from '@mantine/modals';

type Props = {
  onConfirm: () => void;
  loading: boolean;
};

export function DowngradeButton({ onConfirm, loading }: Props) {
  const openConfirmModal = () =>
    modals.openConfirmModal({
      title: '無料プランに変更しますか？',
      children: (
        <List size="sm" spacing="xs">
          <List.Item>期末（現在の請求期間の終わり）までは、有料プランのまま使えます。</List.Item>
          <List.Item>
            期末以降は、このテナントの API
            キーが使えなくなり、次回のログインから無料プランになります。
          </List.Item>
          <List.Item>期末より前であれば、この画面から取り消せます。</List.Item>
        </List>
      ),
      labels: { confirm: '無料プランに変更', cancel: 'キャンセル' },
      confirmProps: { color: 'red' },
      onConfirm,
    });

  return (
    <Button color="red" variant="outline" loading={loading} onClick={openConfirmModal}>
      無料プランに変更
    </Button>
  );
}
